import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Loading } from "@/components/shared";
import Landing from "@/pages/Landing";
import ReferralLanding from "@/pages/ReferralLanding";
import AskLanding from "@/pages/AskLanding";
import BranchProfile from "@/pages/BranchProfile";
import ClaimDiscount from "@/pages/ClaimDiscount";
import ShowCode from "@/pages/ShowCode";
import Login from "@/pages/Login";
import ReferrerApp from "@/pages/ReferrerApp";
import BusinessPortal from "@/pages/BusinessPortal";
import AdminApp from "@/pages/AdminApp";
import { TermsPage, PrivacyPage } from "@/pages/Legal";
import "@/App.css";

function AppRoutes() {
  const { ready } = useAuth();
  // Hold a full-page loading state until localStorage token is checked —
  // prevents a flash of the logged-out chrome / login CTA.
  if (!ready) {
    return (
      <div className="flex min-h-screen flex-col" data-testid="auth-boot-splash">
        <Loading />
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/r/:code" element={<ReferralLanding />} />
      <Route path="/ask/:code" element={<AskLanding />} />
      <Route path="/b/:branchId" element={<BranchProfile />} />
      <Route path="/claim/:code" element={<ClaimDiscount />} />
      <Route path="/redeem/:code" element={<ShowCode />} />
      <Route path="/login" element={<Login />} />
      <Route path="/app/*" element={<ReferrerApp />} />
      <Route path="/business/*" element={<BusinessPortal />} />
      <Route path="/admin/*" element={<AdminApp />} />
      <Route path="/admin/login" element={<AdminApp />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
